/**
 * @module FieldControls
 */
import { FormControl, FormControlLabel, FormHelperText, Checkbox as MuiCheckbox } from '@material-ui/core';
import { deepMerge } from '@sensenet/client-utils';
import React, { useState } from 'react';
import { changeTemplatedValue } from "../helpers.js";
import { renderIconDefault } from "./icon.js";
import { defaultLocalization } from "./localization.js";
/**
 * Field control that represents a Checkbox field.
 */

export const Checkbox = props => {
  var _props$localization, _changeTemplatedValue;

  const localization = deepMerge(defaultLocalization.checkbox, (_props$localization = props.localization) === null || _props$localization === void 0 ? void 0 : _props$localization.checkbox);
  const initialState = props.fieldValue == null && props.actionName === 'new' ? ((_changeTemplatedValue = changeTemplatedValue(props.settings.DefaultValue)) === null || _changeTemplatedValue === void 0 ? void 0 : _changeTemplatedValue.toLowerCase()) === 'true' : !!props.fieldValue;
  const [value, setValue] = useState(initialState);

  const handleChange = () => {
    var _props$fieldOnChange;

    setValue(!value);
    (_props$fieldOnChange = props.fieldOnChange) === null || _props$fieldOnChange === void 0 ? void 0 : _props$fieldOnChange.call(props, props.settings.Name, !value);
  };

  switch (props.actionName) {
    case 'edit':
    case 'new':
      return /*#__PURE__*/React.createElement(FormControl, {
        required: props.settings.Compulsory,
        disabled: props.settings.ReadOnly
      }, /*#__PURE__*/React.createElement(FormControlLabel, {
        name: props.settings.Name,
        control: /*#__PURE__*/React.createElement(MuiCheckbox, {
          checked: value,
          onChange: handleChange
        }),
        label: props.settings.DisplayName
      }), !props.hideDescription && /*#__PURE__*/React.createElement(FormHelperText, null, props.settings.Description));

    case 'browse':
    default:
      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          marginRight: '0.5rem'
        }
      }, props.settings.DisplayName), props.fieldValue != null ? props.renderIcon ? props.renderIcon(props.fieldValue ? 'check' : 'not_interested') : renderIconDefault(props.fieldValue ? 'check' : 'not_interested') : localization.noValue);
  }
};
//# sourceMappingURL=checkbox.js.map